import { LoggerHelper, MainAppIndex } from '@src';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
      <MainAppIndex />
    </BrowserRouter>
  </StrictMode>
);

/*
  O service worker é o que torna o app instalável: o navegador só oferece
  "adicionar à tela inicial" -- e só dispara beforeinstallprompt -- quando há
  manifest, origem segura e um service worker registrado. Sem ele o convite de
  instalação nunca aparece no Android.

  Registrado apenas em produção porque é só lá que o arquivo existe: o
  GenerateSW do webpack não roda sob o dev server, e tentar registrá-lo em
  desenvolvimento renderia um 404 a cada carregamento.
*/
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        LoggerHelper.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        LoggerHelper.log('SW registration failed: ', registrationError);
      });
  });
}
